/** Part D Customer 360 public APIs — plain JSON, no JWT, no AES body. */
const PLAIN_CUSTOMER_360_ENDPOINTS = [
  'captureCustomerActivity',
  'extractCustomerActivityDocument',
  'uploadCustomerCaptureDocument',
  'getLeadIdByCustomerId',
  'createWebChatLead',
  'createLiveChatLead',
  'getCustomerFeedback',
  'createCustomerFeedback',
  'getCustomerDocuments',
  'createCustomerDocument',
  'createSupportRecord',
];

/** Part D customer intelligence — plain JSON, no JWT, no AES body. */
const PLAIN_CUSTOMER_INTELLIGENCE_ENDPOINTS = [
  'getLeadCustomerIntelligence',
  'customer-intelligence',
  'lambda-url',
];

export function isPlainCustomer360ApiUrl(url: string): boolean {
  if (typeof url !== 'string') return false;
  return (
    PLAIN_CUSTOMER_360_ENDPOINTS.some((endpoint) => url.includes(endpoint)) ||
    PLAIN_CUSTOMER_INTELLIGENCE_ENDPOINTS.some((endpoint) => url.includes(endpoint))
  );
}

/** @deprecated use isPlainCustomer360ApiUrl */
export function isPlainCaptureCustomerActivityUrl(url: string): boolean {
  return isPlainCustomer360ApiUrl(url);
}
